import type { AudioMetadata } from '@/types/Ibexa'
import useRelation from './useRelation'


export function useFetchAudioFile() {
  const { getRelatedContentFields } = useRelation()

  async function fetchAudioFile(audioId: number | string | undefined): Promise<AudioMetadata | undefined> {
    if (!audioId) return undefined
    if (typeof audioId === 'string') audioId = parseInt(audioId, 10)
    return (await getRelatedContentFields<AudioMetadata>([audioId]))[0]
  }

  return { fetchAudioFile }
}